<template>
    <div>
        <div class="nav">
            <page-navigation v-bind:step="currentStep"></page-navigation>
        </div>
        <div class="content_main" style="overflow: hidden;">
            <h3 class="line_red" style="float: left;">模型计算</h3>
           <div id="root" style="float: left;">
                   <div class="element-a" @mouseover="gifShow()" @mouseleave="gifHidden()" style="float: right; padding-left:10px; padding-top:1px;">
                      <img class="information"  src="../../assets/tipp_icon.png" style="float: right;">
                      </div>
                       <div class="gif-wrap">
                         <img class="gif" src="../../assets/step 4.gif" id="gif" v-show="ifShowB"
             @mouseover="gifMouseOver" @mouseleave="gifMouseLeave">
                     </div>
                  </div>
            <div class="content_header">
                <span>* 一次最多可选择</span>
                <span class="red_color">{{tableData.length}}条</span>
                <span>记录</span>
                <span>已选 {{count}} / {{tableData.length}}</span>
            </div>
            <div class="table_panel">
                <ul class="table_header">
                    <li class="table_header_row">
                        <ul>
                            <li class="small">POS ID</li>
                            <li class="large">店铺名称</li>
                            <li class="middle">季度</li>
                            <li class="small">操作</li>
                        </ul>
                    </li>
                </ul>
                <ul class="table_content">
                    <li class="table_row" v-for="(item,index) in tableData">
                        <ul>
                            <li class="small">{{item.pos_id}}</li>
                            <li class="large">{{item.name}}</li>
                            <li class="middle">{{item.season}}</li>
                            <li class="small">
                                <input type="checkbox" name="default" v-bind:id="index">
                                <label v-bind:for="index" v-on:click="checkStore(item,index)"></label>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="panel_bottom">
                <button class="btn btn_bg" v-on:click="submit()">计算</button>
            </div>
        </div>
        <page-footer v-bind:footerStatus="status" v-bind:next="nextUrl" v-bind:prev="prevUrl"></page-footer>
        <tip v-if="ifShow && sendMessage.length > 0" v-bind:status="sendStatus" v-bind:message="sendMessage"></tip>
        <div v-if="ifShowAlert" class="confirm">
          <div class="content">
            <div class="title">
              <span>提示</span>
            </div>
            <div class="text">确认提交{{count}}行模型计算请求?</div>
            <div class="btn_line">
              <button class="btn btn_color" v-on:click="sure()">确认</button>
              <button class="btn btn_cancel" v-on:click="cancel()">取消</button>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import PageNavigation from "@/components/common/PageNavigation";
import PageFooter from "@/components/common/PageFooter";
import Tip from "@/components/common/tip";
import { mapState, mapActions } from "vuex";
import { calculateSubmit, getLastTime } from "../../util/api.js";

export default {
  name: "Calculate",
  components: { PageNavigation, PageFooter, Tip },
  data() {
    return {
    ifShowB: false,
    BFocused: false,
      status: {
        type: "config",
        status: "middle"
      },
      prevUrl: "SettingWeeks",
      nextUrl: "result",
      currentStep: 4,
      checkedList: [],
      checkListAfter: {},
      count: 0,
      sendStatus: false,
      sendMessage: "",
      ifShowAlert:false
    };
  },
  computed: mapState({
    ifShow: state => state.ifShowMessage,
    tableData:state => state.store
  }),
  mounted: function() {
    let that = this;
    that.$store.commit("getCheckedSeason", {});
    that.$store.commit("getIfShowMessage", false);
    that.$store.commit("getStoreList", []);
    getLastTime({ userId: this.getCookie('rstuserId') })
        .then(function(res) {
          if (res.data.success) {
            let result = res.data.result;
            if (!result) {
              return [];
            }
            let array = Object.keys(result);
            let data = [];
            array.forEach(element => {
              let seasonArray = result[element]["seasons"];
              seasonArray.forEach(ele => {
                data.push({
                  pos_id: element,
                  name: result[element]["posName"],
                  season: ele
                });
              });
            });
            console.log(data);
            that.$store.commit("getStoreList", data);
          }
        })
        .catch(function() {});
      this.$nextTick(function() {
        window.confirm = function (message) {
          var iframe = document.createElement("IFRAME");
          iframe.style.display = "none";
          iframe.setAttribute("src", 'data:text/plain,');
          document.documentElement.appendChild(iframe);
          var alertFrame = window.frames[0];
          var result = alertFrame.window.confirm(message);
          iframe.parentNode.removeChild(iframe);
          return result;
      }
      })
  },
  methods: {
    getCookie: function(name) {
      var arr;
      var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      else return null;
    },
    gifShow() {
        this.ifShowB = true;

      },

      gifHidden() {
        
   
        if (!this.BFocused) {
          this.ifShowB = false;
        } else
          this.ifShowB = true;
      },

     
      gifMouseOver() {
        this.ifShowB = true;
        this.BFocused = true;
      },

      gifMouseLeave() {
        
       
        this.BFocused = false;
        this.ifShowB = false;
      },

    checkStore: function(item, index) {
      if (this.checkListAfter[item.pos_id]) {
        if (this.checkListAfter[item.pos_id].indexOf(item.season) != -1) {
          this.checkListAfter[item.pos_id].forEach((element, i) => {
            if (element == item.season) {
              this.checkListAfter[item.pos_id].splice(i, 1);
              this.count--;
              if(this.checkListAfter[item.pos_id].length == 0){
                delete this.checkListAfter[item.pos_id];
              }
            }
          });
        } else {
          this.checkListAfter[item.pos_id].push(item.season);
          this.count++;
        }
      } else {
        this.checkListAfter[item.pos_id] = [item.season];
        this.count++;
      }
      console.log(this.checkListAfter);
    },
    submit:function(){
      let that = this;
      let result = JSON.parse(this.getCookie("posResult"));
      let data = {};
      if (that.count > 0) {
        this.ifShowAlert = true;
        return;
      } else {
        that.$store.commit("getIfShowMessage", true);
        that.sendStatus = false;
        that.sendMessage = "0行计算数据被选择，请再次选择";
        return;
      }
    },
    calculate: function() {
        this.$store.commit("getCheckedSeason", {data:this.checkListAfter});
        this.$router.push("result");
    },
    sure:function(){
      this.ifShowAlert = false;
      this.calculate();
    },
    cancel:function(){
      this.ifShowAlert = false;
    }
  }
};
</script>
<style scoped>
li {
  list-style: none;
}
.nav {
  padding: 0.1rem 0 0.1rem 0;
}
@media screen and (max-height: 650px) {
    .content_main {
      background-color: #fff;
      width: 10rem;
      height: 5.99rem;
      margin: 0 auto;
      margin-bottom: 0.77rem;
      padding-top: 0.19rem;
      box-shadow: 0 0 5px -3px #000;
      position: relative;
    }
}
@media screen and (min-height: 650px) {
    .content_main {
      background-color: #fff;
      width: 10rem;
      height: 5.99rem;
      padding-top: 0.19rem;
      margin-top: 0.2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      box-shadow: 0 0 5px -3px #000;
    }
}
.content_main h3 {
  text-align: left;
}
.line_red:before {
  display: inline-block;
  width: 0.04rem;
  height: 0.24rem;
  vertical-align: middle;
  content: "";
  margin-right: 0.24rem;
  background-color: #fa5400;
}
.content_header {
  padding-left: 0.26rem;
  text-align: left;
  padding-top: 0.55rem;
}
.red_color {
  color: #fa5400;
}
.table_panel {
  padding: 0.13rem 0.2rem 0 0.27rem;
}
.table_header_row ul,
.table_row ul {
  overflow: hidden;
}
.table_header_row ul {
  background-color: #eeeeee;
}
.table_row:nth-child(n) ul {
  background-color: #fff;
}
.table_row:nth-child(2n) ul {
  background-color: #f9f9f9;
}
.table_header_row li,
.table_row li {
  float: left;
  border-right: 2px solid #fff;
  height: 0.45rem;
  line-height: 0.45rem;
}
.table_header_row li:last-child,
.table_row li:last-child {
  border-right: 0;
}
.small {
  width: 10%;
}
.middle {
  width: 20%;
}
.large {
  width: 60%;
}
.element-a:hover{
            cursor: pointer;
        }
.gif {
    width: 800px;
    height: 480px;
    font-size: 1rem;
    position: absolute;
    border-radius: 10px;
    top: 0px;
    left: 0px;
        }
.gif-wrap{
    opacity: 0;
    -webkit-transition:all 1.0s ease-in-out;
    -moz-transition:all 1.0s ease-in-out;
    -o-transition:all 1.0s ease-in-out;
    -ms-transition:all 1.0s ease-in-out;
    transition:all 1.0s ease-in-out;
}    
.gif-wrap:hover{
    cursor: pointer;
    opacity: 1;
}
input {
  display: none;
}
label {
  vertical-align: middle;
  cursor: pointer;
  line-height: 0.21rem;
  height: 0.21rem;
  display: inline-block;
}
input + label::before {
  content: "";
  background: url(../../assets/check.png) no-repeat;
  width: 0.21rem;
  height: 0.21rem;
  display: block;
  padding-right: 0.07rem;
  background-size: 0.19rem 0.19rem;
}
input:checked + label::before {
  background: url(../../assets/checked.png) no-repeat;
  background-size: 0.19rem 0.19rem;
}
.panel_bottom {
  position: absolute;
  bottom: 0.27rem;
  right: 0.22rem;
}
.btn {
  width: 1.17rem;
  height: 0.46rem;
  border: 0;
  border-radius: 3px;
  font-size: 0.15rem;
}
.btn_bg {
  background-color: #000;
  color: #fff;
}
.confirm{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #0006;
}
.confirm .content{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 360px;
    height: 200px;
    border: 1px solid #eeeeee;
    border-radius: 2px;
    background-color: #fff;
}
.confirm .title{
    height: 40px;
    text-align: left;
    line-height: 40px;
    padding-left: 20px;
    background: #eeeeee;
    font-weight: bold;
}
.confirm .text{
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
}
.btn_line .btn{
    width: 70px;
    height: 30px;
    border: 0;
    border-radius: 2px;
    color: #fff;
    margin-left: 10px;
}
.btn_line .btn_color{
  background-color: #fa5400;
}
.btn_line .btn_cancel{
  background-color: #eee;
}
</style>




// WEBPACK FOOTER //
// src/components/page/Calculate.vue